import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

const InwinnableCell = ({ value }) => {
  return value ? <Text size={11}>inwinnable</Text> : <Text size={11}>not inwinnable</Text>
}

InwinnableCell.propTypes = {
  value: PropTypes.bool,
}

export { InwinnableCell }
